import { createCategory } from './create'
import { deleteCategory } from './delete'
import { updateCategory } from './update'

export const categories = {
  create: createCategory,
  update: updateCategory,
  delete: deleteCategory,
}
